<template>
  <v-row justify="center">
    <v-dialog v-model="shower" scrollable width="1100px" persistent>
      <v-card class="rounded-lg">
        <v-card-title>
          {{ $t("email.ListCheck") }}
          <v-spacer></v-spacer>
          <v-btn
            class="mr-3"
            v-if="StatusNotAvailable || NotAvailable.length > 0"
            color="#077893"
            dark
            :loading="LoadingSentConsent"
            @click="Fn_ConfirmConsent()"
          >
            {{ $t("onechat.send") }}</v-btn
          >
          <v-btn
            outlined
            color="error"
            style="float: right"
            @click="Fn_Close()"
          >
            {{ $t("consentform.close") }}</v-btn
          >
        </v-card-title>
        <br />
        <v-card-text>
          <v-card outlined>
            <v-data-table
              v-if="StatusNotAvailable || NotAvailable.length > 0"
              :headers="headers"
              :items="NotAvailable"
              :items-per-page="rowPerpage"
              class="pa-0"
            >
              <template v-slot:[`item.Status`]="{ item }">
                <v-chip v-if="item.Status == false" color="#388E3C" dark>
                  ส่งสำเร็จ
                </v-chip>
                <v-chip v-if="item.Status == true" color="#B71C1C" dark>
                  {{ item.Message }}
                </v-chip>
              </template>
              <template v-slot:[`item.Note`]="{ item }">
                <div class="red--text">{{ item.ErrorMessage }}</div>
              </template>
            </v-data-table>
            <v-data-table
              v-else
              :headers="headers"
              :items="Available"
              :items-per-page="rowPerpage"
              :page.sync="Page"
              @page-count="PageCount = $event"
              class="pa-0"
            >
              <template v-slot:[`item.Status`]="{ item }">
                <v-chip v-if="item.Status == false" color="#388E3C" dark>
                  ส่งสำเร็จ
                </v-chip>
                <v-chip v-if="item.Status == true" color="#B71C1C" dark>
                  {{ item.Message }}
                </v-chip>
              </template>
              <template v-slot:[`item.Note`]="{ item }">
                <div class="red--text">{{ item.ErrorMessage }}</div>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
        <!-- <v-card-actions class="mb-5">
          <v-layout row wrap justify-center align-center>
            <v-flex xs11 lg11 md11 sm11>
              <v-pagination
                total-visible="10"
                circle
                color="#077893"
                v-model="Page"
                :length="PageCount"
              >
              </v-pagination>
            </v-flex>
          </v-layout>
        </v-card-actions> -->
      </v-card>
    </v-dialog>
    <DialogListGeneralConsent
      :show="DialogListGeneral"
      :_detail="ItemsConsent"
      @closeDialogDelete="DialogListGeneral = false"
    />
    <DialogListGroupConsent
      :show="DialogListGroup"
      :_detail="ItemsConsent"
      @closeDialogDelete="DialogListGroup = false"
    />
  </v-row>
</template>
<script>
import DialogListGeneralConsent from '@/components/dialog/DialogConsentGeneralEmailCreate.vue'
import DialogListGroupConsent from '@/components/dialog/DialogConsentGroupOnechatCreate'
import authorization from '@/functions/authorization.js'
import Swal2 from 'sweetalert2/dist/sweetalert2.js'
import { mapGetters } from 'vuex'
const Toast = Swal2.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000
})
export default {
  props: ['show', '_detail'],
  components: {
    DialogListGeneralConsent,
    DialogListGroupConsent
  },
  data: function () {
    return {
      Page: 1,
      PageCount: 0,
      rowPerpage: 10,
      LoadingSentConsent: false,
      Available: [],
      NotAvailable: [],
      ItemsConsent: [],
      StatusNotAvailable: false,
      DialogListGeneral: false,
      DialogListGroup: false,
      serviceEmail: '',
      SelectConsentGroup: '',
      SelectConsentGeneral: ''
    }
  },
  created () {},
  computed: {
    ...mapGetters(['DataGroupConsent']),
    ...mapGetters(['DataGroupOneChatSearch']),
    shower: {
      get () {
        return this.show
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
    _DataGroupOneChatSearch: {
      get () {
        return this.DataGroupOneChatSearch || '-'
      }
    },
    _profile: {
      get () {
        return this.$store.getters.profile
      }
    },
    _apiKey: {
      get () {
        return this.$store.getters.apikey
      }
    },
    _accesskey: {
      get () {
        return this.$store.getters.accessKey
      }
    },
    headers: {
      get () {
        return [
          {
            text: this.$i18n.t('dashboard.num'),
            value: 'row',
            align: 'center',
            sortable: false
          },
          {
            text: this.$i18n.t('onechat.name'),
            value: 'NameTh',
            align: 'left',
            sortable: false
          },
          {
            text: this.$i18n.t('consentlist.Email'),
            value: 'Email',
            align: 'left',
            sortable: false
          },
          {
            text: this.$i18n.t('onechat.status'),
            value: 'Status',
            align: 'center',
            sortable: false
          },
          {
            text: this.$i18n.t('onechat.Note'),
            value: 'Message',
            align: 'center',
            sortable: false
          }
        ]
      }
    },
    _SendId: {
      get () {
        return this.DataGroupConsent.SendId || '-'
      }
    }
  },
  watch: {
    show (val) {
      if (val === true) {
        this.Available = this._detail.Available
        this.NotAvailable = this._detail.NotAvailable
        this.fn_setData()
        var Status = this.NotAvailable.find((item) => item.Status === true)
        this.StatusNotAvailable = Status
      }
    }
  },
  mounted () {},
  methods: {
    async Fn_CopyDetail (val) {
      await navigator.clipboard.writeText(val)
    },
    fn_setData () {
      for (var j in this.NotAvailable) {
        this.NotAvailable[j].row = parseInt(j) + 1
      }
      for (var i in this.Available) {
        this.Available[i].row = parseInt(i) + 1
      }
    },
    Fn_Close () {
      this.$emit('closeDialogDelete')
    },
    async Fn_ConfirmConsent () {
      this.LoadingSentConsent = true
      for (var i in this.NotAvailable) {
        delete this.NotAvailable[i].Status
        delete this.NotAvailable[i].Message
      }
      if (this._DataGroupOneChatSearch.Type === 'General') {
        this.SelectConsentGeneral =
          this._DataGroupOneChatSearch.Detail.Consent[0].ConsentId
        this.SelectConsentGroup = ''
      } else if (this._DataGroupOneChatSearch.Type === 'Group') {
        this.SelectConsentGeneral = ''
        this.SelectConsentGroup =
          this._DataGroupOneChatSearch.Detail.Consent[0].GroupId
      }
      var payload = {
        UserName: this.$cookies.get('OneUsername'),
        BusinessId: this.$cookies.get('BusinessId'),
        AccountId: this.$cookies.get('OneAccountId'),
        Receiver: this.NotAvailable,
        ConsentGroupId: this.SelectConsentGroup,
        Consent: this.SelectConsentGeneral,
        PolicyId: this._DataGroupOneChatSearch.Detail.Policy[0].PolicyId,
        UserId: this.$cookies.get('OneAccountId'),
        GroupSend: this._DataGroupOneChatSearch.Detail.GroupSend,
        ShowPolicy: true,
        TransactionId: this.$cookies.get('TransactionIdEmail').TransactionId, //
        TemplateEmail: this.$cookies.get('TransactionIdEmail').TemplateId //
      }
      var Headers = {
        AccountId: this.$cookies.get('OneAccountId')
      }
      var dataEncode = await authorization.encodeDataNew(payload)
      var auth = await authorization.encodeDataNew(Headers)
      var headers = { Authorization: 'Bearer ' + auth }
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + 'email/GetConsentAddOn',
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.LoadingSentConsent = false
          if (response.data.Status === 'OK') {
            this.$emit('closeDialogDelete')
            this.ItemsConsent = response.data.Message
            if (this._DataGroupOneChatSearch.Type === 'Group') {
              this.DialogListGroup = true
            } else {
              this.DialogListGeneral = true
            }
          } else {
            this.LoadingSentConsent = false
            Toast.fire({
              icon: 'error',
              title: response.data.ErrorMessage
            })
          }
        })
        .catch((error) => {
          this.LoadingSentConsent = false
          if (error.response) {
            Toast.fire({
              icon: 'error',
              title: error.response.data.ErrorMessage
            })
          } else if (error.request) {
            Toast.fire({
              icon: 'error',
              title: error.request
            })
          } else {
            Toast.fire({
              icon: 'error',
              title: error.message || error
            })
          }
        })
    }
  }
}
</script>
<style scoped>
.noteStlye {
  width: 150px;
  word-wrap: break-word;
}
</style>
